import React, { useRef, useEffect } from 'react';
import IconButton from '@mui/material/IconButton';
import CopyIcon from 'src/assets/icons/CopyIconV2';
import CustomTooltip from '../Popover/CustomTooltip';

const Input = ({ id, label, classes, action, title, checked, value, name, disabled = 0, copyText = false, showLabelTooltip = false , checkStyle, noTick = false, indeterminate = false}) => {
  const sectionRef = useRef(null);
  const checkboxRef = useRef(null);

  const handleMouseEnter = () => {
    if (sectionRef.current) {
      sectionRef.current.classList.add('show-Copy');
    }
  };

  const handleMouseLeave = () => {
    if (sectionRef.current) {
      sectionRef.current.classList.remove('show-Copy');
    }
  };

  // Set indeterminate state on checkbox (must be done via JavaScript, not HTML)
  // Note: indeterminate visual is handled by CSS class 'indet_check', not by this prop
  useEffect(() => {
    if (checkboxRef.current && indeterminate) {
      checkboxRef.current.indeterminate = indeterminate;
    }
  }, [indeterminate]);

  return (
    <React.Fragment>
      {/* <div className={`form-group check-box ${classes}`}>
        <input type="checkbox" className="mr-2" checked={checked} id={id} value={value} onChange={action} />
        <label htmlFor={id}>{label}</label>
      </div> */}
    <section  
      ref={sectionRef}
      className={`d-flex align-items-center gap-4 ${checked ? 'checkedFontColor' : ''}`}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      >
      <label className={`checkbox ${classes}`} htmlFor={id}>
        {!noTick && <input type="checkbox" ref={checkboxRef} name={name} checked={checked} id={id} value={value} onChange={action} disabled={disabled} />}
        {!noTick && <span className={`checkmark ${checkStyle}`}></span>}
        {!showLabelTooltip && label && <span title={title?label:''} className="ml-2 label-name">{label}</span>}
        {showLabelTooltip && label && <CustomTooltip title={label}><span className="ml-2 label-name">{label}</span></CustomTooltip>}
      </label>
      {copyText ? <CopyAction label={label} /> : null}
      </section>
    </React.Fragment>
  );
};

export const CopyAction = ({label, customClass = 'copy_icn_v2'}) => {
  const copyRef = useRef(null)

  return (
    <IconButton
        aria-label="copy"
        size="small"
        ref={copyRef}
        onClick={(e) => {
          e.stopPropagation();
          copyRef.current.classList.add('animate');
          navigator.clipboard.writeText(label);
          setTimeout(() => {
            copyRef.current?.classList?.remove('animate');
          }, 500);
        }}
        className={customClass}
      >
      <CopyIcon width={15} height={15} />
    </IconButton>
  )
}

export default Input;
